import React, { Component } from "react"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { actions as appActions } from "../../modules/appModule"
import { actions as userActions } from "../../modules/userModule"
import { COLOR, PATH } from "../../modules/constants"

import Page, { Content } from "../../components/Page"
import DashboardNavbar from "../../components/layout/DashboardNavbar"
import Footer from "../../components/Footer"
import MyAccountForm from "../../forms/MyAccountForm"

class MyAccount extends Component {
  render() {
    return (
      <React.Fragment>
        <DashboardNavbar title="My Account" backLink portrait={this.props.portrait} />

        <Page>
          <Content scroll>
            <div className="form-page">
              <div className="form-cell">

                <div className="form-wrapper">
                  <MyAccountForm
                    onSubmit={form => this.props.app.userDetailsChanged(form)}
                    brandColor={COLOR.BRAND.STD}
                  />

                  <p className="error-message">{this.props.userDetailsChangedError}</p>
                  <hr />
                  <div className="field">
                    <br />
                    <br />
                    <p className="alternative-link" style={{ color: COLOR.BRAND.STD }} >
                      If you no longer wish to use the Numerable web app you can <Link to={`/${PATH.DELETE_ACCOUNT}`} style={{ color: COLOR.BRAND.STD }} >delete your account</Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Content>
        </Page>

        <Footer urlSource={this.props.urlSource} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ app, common, user }) => {
  return {
    portrait: user.portrait,
    urlSource: common.urlSource,
    userDetailsChangedError: app.userDetailsChangedError,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    app: bindActionCreators(appActions, dispatch),
    user: bindActionCreators(userActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount)

